import React from 'react'
import TripAdvisorLogo from '../../assets/tripwinners.png';
import BackroundZebra from '../../assets/zebrastone.jpeg';

function PulsaticTripAdvisor() {
  return (
    <div className="content-sect-zeb zebra-back-story" style={{ 
        backgroundImage: `url(${BackroundZebra})` 
      }}>
       <div className="overlay">
           <div className="container inner-zib ">
               <div className="row">
               <div className="col-md-7">
                    <div className="txtwhite">
                    <p>Pulsating cities. Vast wilderness. Fascinating history and colourful cultures. From the towering cliffs of the Table Mountain to the gritty streets of Soweto, excitement lies around every corner in vibrant South Africa.</p>
                    <p>Whether you&rsquo;re looking to rub shoulders with locals on a tour of Johannesburg, explore further afield with a tour of Cape Town or Kruger National Park, or you&rsquo;re simply in need of a transfer from the airport to your hotel, who better to provide personalised service than your own personal tour guide?</p>
                    <p>Stephenson Adventures offers a range of transfer and touring services that will immerse you in the best South Africa has to offer.</p>
                    </div>
                </div>
                <div className="col-md-5 text-center">
                    <img src={TripAdvisorLogo} className="img-responsive trip-image" />
                </div>
               </div>
            </div>
       </div>
    </div>
  )
}

export default PulsaticTripAdvisor